export const createPedidoModel = ({
  id_interno = '',
  id_empresa = '',
  id_saida = '',
  data_emissao = '',
  id_cliente = '',
  cliente = '',
  razao_social = '',
  nome_fantasia = '',
  total_bruto = '',
  total_desconto = '',
  total_produto = '',
  id_condicao_pagamento = '',
  condicao_pagamento = '',
  id_tabela_preco = '',
  tabela_preco = '',
  status = '',
  itens = [],
  parcelas = [],
  observacoes = ''
} = {}) => ({
  id_interno,
  id_empresa,
  id_saida,
  data_emissao,
  id_cliente,
  cliente: cliente || nome_fantasia,
  razao_social,
  nome_fantasia,
  total_bruto,
  total_desconto,
  total_produto,
  id_condicao_pagamento,
  condicao_pagamento,
  id_tabela_preco,
  tabela_preco,
  status,
  itens,
  parcelas,
  observacoes
});